import React, { useState } from 'react';
import Imgix from 'react-imgix';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import useCreateCartProduct from '../../../../../../hooks/useCreateCartProduct';
import { TransparentButton } from '../../../../../../styles/theme/default/buttons';
import { BodyThree } from '../../../../../../styles/theme/default/typography';
import { getImgixUrl, getName, getPrice } from '../../../../../../utils/helper';
import WaitlistButton from '../../../../common/waitlistButton/WaitlistButton';

const Wrapper = styled.div`
  .name,
  .price,
  .size {
    text-align: center;
  }

  .name {
    margin-top: 10px;
  }

  .add-to-cart-btn {
    margin-top: 15px;
    width: 180px;
    background-color: ${({ theme }) => theme.old ? 'unset' : theme.colors.olive};
    color: ${({ theme }) => theme.old ? 'unset' : 'white'};
  }

  .price {
    margin-top: 10px;
    margin-bottom: 5px;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

function Product({ product, source, toggleCart }) {
  const [buttonText, setButtonText] = useState('Add to Cart');
  const [
    handleAddToCart,
    { loading: loadingAddToCart }
  ] = useCreateCartProduct();

  const handleClick = async () => {
    try {
      await handleAddToCart({ product, quantity: 1, source: source });
      setButtonText('Added');
    } catch (err) {
      setButtonText(`Not available`);
    }
  };
  return (
    <Wrapper>
      <div className="image-side">
        <ImageContainer>
          <Link
            onClick={() => {
              window.scrollTo(0, 0);
              if (toggleCart) {
                toggleCart();
              }
            }}
            to={`/products/${product.slug}`}
          >
            <Imgix
              className="product-image"
              imgixParams={{ auto: 'compress,format' }}
              sizes="(min-width: 993px) 300px,
                  80vw"
              src={getImgixUrl(product.images[0]?.path)}
              htmlAttributes={{
                alt: product.name,
                loading: 'lazy'
              }}
            />
          </Link>
        </ImageContainer>
      </div>
      <div className="content">
        <BodyThree bold={true} className="name">
          {getName(product.name)}
        </BodyThree>
        <BodyThree color="#6c6c6c" bold={true} className="price">
          ${getPrice(product.price)}
        </BodyThree>
        <BodyThree bold={true} className="size">
          {product.frame.size.name}
        </BodyThree>
        {product.is_purchasable ? (
          <TransparentButton
            onClick={handleClick}
            className="add-to-cart-btn"
            disabled={loadingAddToCart || buttonText === 'Added'}
          >
            {loadingAddToCart ? (
              <div
                style={{
                  borderWidth: '2px',
                  width: 15,
                  height: 15
                }}
                className="spinner-border text-dark"
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
              <span className="button-text">
                {buttonText}{' '}
                {buttonText === 'Added' && (
                  <img
                    src="https://theinside.imgix.net/icons/blue-ticket.svg"
                    alt="success ticket"
                  />
                )}
              </span>
            )}
          </TransparentButton>
        ) : (
          <WaitlistButton product={product} />
        )}
      </div>
    </Wrapper>
  );
}

export default Product;

const ImageContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-bottom: 100%;
  overflow: hidden;

  a {
    position: absolute !important;
    top: 0;
    left: 0;
    background: #f7f9fa;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    overflow: hidden;

    .product-image {
      transition: all 0.5s ease;
      position: absolute;
      max-width: 100%;
      max-height: 100%;
      width: 100%;
      height: auto;

      &:hover {
        transform: scale(1.1);
      }
    }
  }
`;
